import React from "react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    // Keep minimal: log for debugging without crashing the whole app.
    // eslint-disable-next-line no-console
    console.error("Unexpected error", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="min-h-screen bg-[#050514] p-8 text-white">
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <div className="text-base font-semibold">Something went wrong</div>
              <div className="mt-2 text-sm text-white/70">
                Please refresh the page.
              </div>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
